module.exports = __webpack_public_path__ + "img/media-8.5b204f69.png";